import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { WipPackerEnvProvider } from './wip-packer-env.service';
import { Observable } from 'rxjs/internal/Observable';
import { TWipPackerSavePayload, TWipPackerSaveResponse } from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class WipPackerDataService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private wipPackerEnvProvider: WipPackerEnvProvider) {}

  save(payload: TWipPackerSavePayload): Observable<TWipPackerSaveResponse> {
    const URL = this.wipPackerEnvProvider.getEnvVar('SAVE');
    return this.http.post<TWipPackerSaveResponse>(URL, payload, this.httpOptions);
  }
}
